exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#tableapp .items-per-page {\n  height: 100%;\n  display: flex;\n  align-items: center;\n  color: #337ab7;\n}\n#tableapp .ignore-css {\n  all: unset;\n}\n", ""]);

// exports
